export type PlanId = 'basic' | 'total'

export interface PlanInfo {
  id: PlanId
  name: string
  shortName: string
  tagline: string
  oldPrice: string
  price: string
  priceNumber: string
  checkoutUrl: string
  featured: boolean
  savings?: string
}

export const PLANS: Record<PlanId, PlanInfo> = {
  basic: {
    id: 'basic',
    name: 'DEFENDETE',
    shortName: 'DEFENDETE',
    tagline: '6 tomos + 4 bonos estratégicos',
    oldPrice: '$35.990',
    price: '$19.990',
    priceNumber: '19.990',
    checkoutUrl: 'https://checkout.solucionesya.shop/cart/48737888829688:1',
    featured: false,
  },
  total: {
    id: 'total',
    name: 'DEFENDETE TOTAL',
    shortName: 'TOTAL',
    tagline: '8 tomos + 4 bonos + 2 tomos exclusivos',
    oldPrice: '$43.990',
    price: '$27.990',
    priceNumber: '27.990',
    checkoutUrl: 'https://checkout.solucionesya.shop/cart/48737891090680:1',
    featured: true,
    savings: 'AHORRÁS $16.000',
  },
}

export const DEFAULT_PLAN: PlanId = 'total'
